import React from 'react';
import { css } from 'emotion';
import { theme } from '@weave/theme-original';
import { Permission } from '@weave/schema-gen-ts/dist/shared/waccess';
import { Route, Switch, useHistory, useLocation } from 'react-router-dom';
import { PrimaryButton, SecondaryButton } from '@weave/design-system';
import { SECURITY } from '../../constants/paths';
import { hasAccess } from '../../helpers/authz';
import { BlockUsersPage } from '../block-users/block-users-page';
import { ManageBannedIpsPage } from '../manage-banned-ips/manage-banned-ips-page';

export const SecurityPage = () => {
  const history = useHistory();
  const { pathname } = useLocation();
  const canManageBannedIps = hasAccess(Permission.SYSTEM_SECURITY_MANAGE);
  const isBlockUsers = pathname === SECURITY.root || pathname === SECURITY.blockUsers;
  const BlockUsersButton = isBlockUsers ? PrimaryButton : SecondaryButton;
  const BannedIpsButton =
    pathname === SECURITY.bannedIps ? PrimaryButton : SecondaryButton;

  return (
    <>
      <nav
        aria-label="Security features"
        className={css`
          background: ${theme.colors.white};
          border-radius: ${theme.borderRadius.medium};
          box-shadow: ${theme.shadows.heavy};
          margin: ${theme.spacing(0, 2, 2)};
          padding: ${theme.spacing(2, 3)};
          display: flex;
          flex-wrap: wrap;
          gap: ${theme.spacing(2)};
          button {
            width: auto;
          }
        `}
      >
        <BlockUsersButton
          type="button"
          aria-current={isBlockUsers ? 'page' : undefined}
          onClick={() => history.push(SECURITY.blockUsers)}
        >
          Block Users
        </BlockUsersButton>
        {canManageBannedIps && (
          <BannedIpsButton
            type="button"
            aria-current={pathname === SECURITY.bannedIps ? 'page' : undefined}
            onClick={() => history.push(SECURITY.bannedIps)}
          >
            Manage Banned IPs
          </BannedIpsButton>
        )}
      </nav>
      <Switch>
        <Route
          exact
          path={[SECURITY.root, SECURITY.blockUsers]}
          component={BlockUsersPage}
        />
        <Route exact path={SECURITY.bannedIps} component={ManageBannedIpsPage} />
      </Switch>
    </>
  );
};
